import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Hourglass = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 21H18V19.3C18 18.7 17.9 18.2 17.7 17.6V17.5C17.5 17.1 17.3 16.6 17 16.3L15.6 14.4C15.2 13.9 15 13.2 15 12.6V11.6C15 10.8 15.3 10 15.9 9.5L16.6 8.8C17.4 8 17.9 7 18 6C18 5.8 18 5.6 18 5.3V3H19C19.6 3 20 2.6 20 2C20 1.4 19.6 1 19 1H5C4.4 1 4 1.4 4 2C4 2.6 4.4 3 5 3H6V5.3C6 5.6 6 5.8 6.1 6C6.2 7.1 6.7 8.1 7.5 8.8L8.2 9.5C8.7 10.1 9 10.9 9 11.7V12.7C9 13.3 8.8 14 8.4 14.5L7 16.3C6.7 16.7 6.5 17.1 6.3 17.5V17.6C6.1 18.2 6 18.8 6 19.3V21H5C4.4 21 4 21.4 4 22C4 22.6 4.4 23 5 23H19C19.6 23 20 22.6 20 22C20 21.4 19.6 21 19 21ZM8 5V3H16V5H8ZM9 17L10 15.7C10.6 14.9 10.9 14 11 13H13C13.1 14 13.4 14.9 14 15.7L15 17H9Z"
      fill="currentColor"
    />
  </svg>
)

export default Hourglass
